import { useQuery, useInfiniteQuery } from "@tanstack/react-query";
import {
  getListAreaOnly,
  getListPropertyCategories,
  getListPropertyCategoriesComplete,
  getAllAreasComplete,
  getListPropertyType,
  getUnitPrice,
  getCountryCodes,
  getListMarketing,
} from "./api";

export const useGetListAreaOnly = ({ params }) => {
  return useQuery({
    queryKey: ["get-list-area-only", params],
    queryFn: () => getListAreaOnly(params),
  });
};

export const useGetListPropertyCategories = ({ params }) => {
  return useQuery({
    queryKey: ["get-list-property-categories", params],
    queryFn: () => getListPropertyCategories(params),
  });
};

export const useGetListPropertyType = ({ params }) => {
  return useQuery({
    queryKey: ["get-list-property-type", params],
    queryFn: () => getListPropertyType(params),
  });
};

export const useGetAllAreasComplete = ({ params } = {}) => {
  return useQuery({
    queryKey: ["get-all-areas-complete", params],
    queryFn: () => getAllAreasComplete(params),
  });
};

export const useGetUnitPrice = (
  { params, enabled = true } = { enabled: true },
) => {
  return useQuery({
    queryKey: ["get-unit-price", params],
    queryFn: () => getUnitPrice(params),
    enabled,
  });
};

export const useGetListPropertyCategoriesComplete = ({ params } = {}) => {
  return useQuery({
    queryKey: ["get-list-property-categories-complete", params],
    queryFn: () => getListPropertyCategoriesComplete(params),
  });
};

export const useGetCountryCodes = ({ params } = {}) => {
  return useQuery({
    queryKey: ["get-country-codes", params],
    queryFn: () => getCountryCodes(params),
  });
};

export const useGetListMarketing = ({ params }) => {
  return useInfiniteQuery({
    queryKey: ["get-list-marketing", params],
    queryFn: ({ pageParam = 1 }) => getListMarketing({ ...params, page: pageParam }),
    getNextPageParam: (lastPage) => {
      const currentPage = lastPage.config?.url?.split("page=")[1] || 1;
      const nextPage = parseInt(currentPage) + 1;

      return !!lastPage?.data?.data?.length ? nextPage : undefined;
    },
    initialPageParam: 1,
  });
};
